<template>
  <div class="p-point-notification-panel-large">
    <div class="p-point-notification-panel-large__icon">
      <slot name="icon" />
    </div>
    <div class="p-point-notification-panel-large__content">
      <p class="p-point-notification-panel-large__title">
        <slot name="title" />
      </p>
      <div class="p-point-notification-panel-large__detail">
        <slot name="detail" />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.p-point-notification-panel-large {
  width: 100%;
  padding: rem(16) rem(24);
  border-radius: px(4);
  display: flex;
  align-items: center;
  justify-content: center;

  &__content {
    margin-left: rem(16);
  }

  &__title {
    font-size: rem(24);
    line-height: 1.6;
    color: $common-white;
    margin-bottom: rem(16);
    font-weight: bold;
  }
}
</style>
